module.exports = __webpack_public_path__ + "static/img/service_on.cca4de2f.svg";